import { useState, useCallback, useEffect } from 'react';

export const useModal = (): [boolean | undefined, () => void, () => void] => {
	const [isOpen, setOpen] = useState(false);

	const open = useCallback(() => {
		setOpen(true);
	}, []);

	const close = useCallback(() => {
		setOpen(false);
	}, []);

	useEffect(() => {
		const onKey = (e: KeyboardEvent) => {
			if (e.keyCode === 27) {
				setOpen(false);
			}
		};

		window.addEventListener('keyup', onKey);
		return () => window.removeEventListener('keyup', onKey);
	}, []);

	return [isOpen, open, close];
};
